import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { INSERT_STALL_DESIGN_REQUEST, UPDATE_STALL_DESIGN_REQUEST, GET_STALL_DESIGN_REQUEST_LIST, GET_STALL_DESIGN_REQUEST_DETAILS, insertStallDesignRequestUrl, updateStallDesignRequestStatusUrl, getStallDesignRequestListUrl, getStallDesignRequestStatusDtlUrl } from '../../utils/constants'


export const insertStallDesignRequest_action = (VendorID, Remark) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
            VendorID: VendorID,
            Remark: Remark,
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosPost(insertStallDesignRequestUrl, params)

        dispatch({
            type: INSERT_STALL_DESIGN_REQUEST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateStallDesignRequestStatus_action = (StallDesignRequestID,StatusID, RefusedRemark) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            StallDesignRequestID: StallDesignRequestID,
            StatusID: StatusID,
            RefusedRemark: RefusedRemark,
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosPost(updateStallDesignRequestStatusUrl, params)

        dispatch({
            type: UPDATE_STALL_DESIGN_REQUEST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getStallDesignRequestList_action = (CompanyName, ExhRegistrationNo,StatusID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            VendorID: sessionStorage.getItem('AccountIDSS'),
            CompanyName: CompanyName,
            ExhRegistrationNo: ExhRegistrationNo,
            StatusID: StatusID,
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosGet(getStallDesignRequestListUrl, params)

        dispatch({
            type: GET_STALL_DESIGN_REQUEST_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getStallDesignRequestStatusDtl_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosGet(getStallDesignRequestStatusDtlUrl, params)

        dispatch({
            type: GET_STALL_DESIGN_REQUEST_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}